import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Box, Button } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import DropdownSelectors from './DropdownSelector';
import themeStyles from './styles/OwnerManuals.styles';
import ErrorUI from './ErrorUI';
import Loader from '../../utils/components/Loader';
const PrimaryButton = themeStyles.apply(Button, 'PrimaryButton');
const SelectVehicleContainer = themeStyles.apply(Box, 'SelectVehicleContainer');
const SelectAVehicle = ({ currentSelectedModel, currentSelectedYear, yearOptionsOnChangeHandler, modelOptionsOnChangeHandler, onViewResourcesClick, isUninitialized, isError, isFetching, yearsOptions, modelOptions, }) => {
    const { t } = useTranslation();
    if (isError) {
        return _jsx(ErrorUI, { message: t('Pages.Owners.Manuals.apiLoadingError') });
    }
    if (isUninitialized || isFetching) {
        return _jsx(Loader, { testId: "cy-manuals-loader" });
    }
    return (_jsxs(SelectVehicleContainer, { children: [_jsx(DropdownSelectors, { selectedModel: currentSelectedModel, selectedYear: currentSelectedYear, yearOptions: yearsOptions, modelOptions: modelOptions, modelOptionsOnChangeHandler: modelOptionsOnChangeHandler, yearOptionsOnChangeHandler: yearOptionsOnChangeHandler }), _jsx(PrimaryButton, { disabled: !(currentSelectedModel.length > 0 && currentSelectedYear.length > 0), onClick: onViewResourcesClick, "data-testid": "cy-view-resource-button", styling: "primary", children: t('Pages.Owners.Manuals.viewResourcesButton') })] }));
};
export default SelectAVehicle;
